module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KW-25d2168eea5206af4e23183af6459438.png";